import React from 'react'
import PageHeader from '../components/PageHeader'

const LibraryNew = () => {


    const digitalLibraryLinks = [
        { title: "National Digital Library", url: "#" },
        { title: "Virtual Lab", url: "https://vlab.amrita.edu/" },
        { title: "Library", url: "#" },
        { title: "Library Rule", url: "#" },
        { title: "E-Content", url: "#" },
        { title: "Download College library list", url: "#" },

        { title: "G.O, U.P. Govt", url: "https://shasanadesh.up.gov.in/" },
        { title: "E-Learning Portal", url: "#" },
        { title: "Open Access E-Journals/Database", url: "#" },
        { title: "CCS University", url: "https://www.ccsuniversity.ac.in/web/digital-lib/home.html" },
        { title: "World eBook Library", url: "#" },
        { title: "e-PG Pathshala", url: "https://epgp.inflibnet.ac.in/" },
        { title: "ICI", url: "http://www.indiancitationindex.com/ici.aspx" },

        { title: "eGazette", url: "#" },
        { title: "E-Book download", url: "https://www.pdfdrive.com/" },
        { title: "National Digital Library", url: "https://ndl.iitkgp.ac.in/index.php" },
        { title: "Sodhe Sindhu", url: "https://www.inflibnet.ac.in/ess/" },
        { title: "Subject Gateway", url: "https://infoport.inflibnet.ac.in/" },
        { title: "eJournal", url: "https://infoport.inflibnet.ac.in/" },
        { title: "Kinbus", url: "https://www.knimbus.com/#/" },

        { title: "UGC Notice", url: "https://www.ugc.ac.in/ugc_notices.aspx" },
        { title: "E-Resources", url: "#" },
        { title: "Open Access Theses and Dissertations", url: "https://oatd.org/" },
        { title: "Hthi Trust", url: "https://babel.hathitrust.org/cgi/ls?field1=ocr;q1=snaskrit;a=srchls;lmt=ft" },
        { title: "NCET eBook", url: "https://infoport.inflibnet.ac.in/" },
        { title: "eNews Papers", url: "https://www.onlinenewspapers.com/index.shtml" },
        { title: "VIDWAN", url: "#" }
    ];
    return (
        <div>
            <PageHeader title="Library" />
            <div className="library-container">

                <div className="library-header">
                    Uttar Pradesh Higher Education Digital Library
                </div>

                <div className="library-grid">

                    {digitalLibraryLinks.map((link, index) => (
                        <div className="library-cell" key={index}>
                            <a href={link.url} className="library-link">
                                {link.title}
                            </a>
                        </div>
                    ))}

                </div>

            </div>

        </div>

    )
}

export default LibraryNew